<template>
  <base-slide-over ref="slideOver" title="Edit Training" size="lg">
    <inline-error id="edit-training-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-text-field label="Name" placeholder="Enter a name for the training" v-model="editName" class="tw-mt-3" required :readonly="isLoading" :maxLength="255" />
      <base-textarea label="Description" placeholder="Enter description" :rows="4" v-model="editDescription" :readonly="isLoading" required />
      <div class="tw-grid tw-grid-cols-3 tw-gap-4">
        <base-text-field
          class="tw-col-span-2"
          label="Category"
          placeholder="Enter a category for the training"
          v-model="editCategory"
          required
          :readonly="isLoading"
          :maxLength="255"
        />
        <base-text-field label="Sort Order" placeholder="Enter a category for the training" v-model="editSortOrder" class="" :readonly="isLoading" :maxLength="255" />
      </div>
      <FormulateForm name="fileInputForm">
        <FormulateInput
          type="file"
          name="file"
          label="Select your training document to upload"
          help="This will replace any exiting files you uploaded."
          validation="required|mime:application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,image/jpeg,image/png,video/mp4,video/x-m4v"
          v-model="document"
        />
      </FormulateForm>
      <FormulateForm name="imageInputForm" class="tw-mt-4">
        <FormulateInput
          type="file"
          name="file"
          label="Select your cover image to upload"
          help="This will replace any exiting files you uploaded."
          validation="required|mime:image/jpeg,image/png"
          v-model="imageFile"
        />
      </FormulateForm>
    </base-form>

    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="hide()" class="tw-mr-3">Cancel</base-button>
        <base-button @click="updateTraining()" :disabled="!isFormValid" :loading="isLoading">Save</base-button>
      </div>
    </template>
  </base-slide-over>
</template>
<script>
import InlineError from "@/components/InlineError";

export default {
  name: "EditTraining",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
    trainingId: String,
    name: String,
    category: String,
    description: String,
    sortOrder: Number,
    imageDocumentId: String,
    documentId: String,
    imageExtension: String,
  },
  data() {
    return {
      isFormValid: true,
      isLoading: false,
      editName: this.name,
      editCategory: this.category,
      editDescription: this.description,
      editSortOrder: this.sortOrder,
      document: null,
      imageFile: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  watch: {
    name() {
      this.editName = this.name;
    },
    category() {
      this.editCategory = this.category;
    },
    description() {
      this.editDescription = this.description;
    },
    sortOrder() {
      this.editSortOrder = this.sortOrder;
    },
  },
  methods: {
    updateTraining() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;

      let documentId = null;
      if (this.document) documentId = this.document.files[0].path.documentId;

      let imageDocumentId = null;
      if (this.imageFile) imageDocumentId = this.imageFile.files[0].path.documentId;

      this.$axios
        .put(`/businesses/${this.businessId}/trainings/${this.trainingId}`, {
          id: this.trainingId,
          documentId: documentId,
          imageDocumentId: imageDocumentId,
          name: this.editName,
          category: this.editCategory,
          description: this.editDescription,
          sortOrder: this.editSortOrder,
        })
        .then(() => {
          this.$emit("saved");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Training Updated", message: `Training ${this.editName} was updated successfully.` });
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Failed to update ${this.name}`;
          this.errorMessage = `Training ${this.name} was not able to be updated. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    show() {
      this.$refs.slideOver.show();
      this.document = null;
      this.imageFile = null;
    },
    hide() {
      this.$refs.slideOver.hide();
    },
  },
};
</script>
